.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
  background: var(--card-bg-color);
  border-radius: var(--border-radius-medium);
  padding: 0.8rem 0.8rem 2.4rem;
  cursor: pointer;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.actions-container {
  display: flex;
  flex-direction: row;
  gap: 1.2rem;

  & > div {
    & > div {
      width: 3.2rem;
      height: 3.2rem;
      background: var(--color-grey-8-5);
      color: var(--color-grey-5);
    }
  }
}

.name {
  font-style: normal;
  font-weight: 700;
  font-size: 1.3rem;
  line-height: 2.9rem;
  color: #f7f8f8;
}

.character-image-container {
  position: relative;
  padding-top: 100%;
}

.requirements {
  font-weight: 400;
  height: 2.4rem;
  font-size: 1.6rem;
  color: var(--color-grey-2);
}

.additional-info-block {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.4rem;
}

.selected-candidate-name {
  font-size: 1.6rem;
  height: 1.9rem;
  color: var(--white-default);
  font-weight: 500;
}

.selected-candidate-title {
  font-weight: 500;
  height: 1.7rem;
  color: var(--color-grey-3);
}

.additional-info-label {
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2rem;
  color: var(--color-grey-5);
}

.cast-list-button {
  all: unset;
  background: var(--color-grey-8-5);
  color: var(--color-grey-2);
  border-radius: var(--border-radius-medium);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  font-weight: 500;
  font-size: 2rem;
  line-height: 2.4rem;
  padding: 0.4rem 0.8rem;

  &:hover {
    background-color: var(--color-grayscale-tuna);
  }
}
